import { lazy } from "react";
import lazyLoad from "../utils/lazy-load";
import IndexLayout from "@/core/layouts/layout";
import NavigationLayout from "@/core/layouts/navigation-layout";
import { RectangleStackIcon, BookOpenIcon, UserIcon } from "@heroicons/react/24/outline";
import { RectangleStackIcon as RectangleStackIconSolid, BookOpenIcon as BookOpenIconSolid, UserIcon as UserIconSolid } from "@heroicons/react/24/solid";
import ViewerLayout from "@/core/layouts/viewer-layout";


export const navigationBottomBarRoutes: Array<NavigationRouteObject> = [
    {
        name: "阅读",
        icon: <RectangleStackIcon />,
        active: <RectangleStackIconSolid />,
        element: lazyLoad(lazy(() => import("@/views/read"))),
        path: '/index/read',
        index: true,
    },
    {
        name: "书架",
        icon: <BookOpenIcon />,
        active: <BookOpenIconSolid />,
        element: lazyLoad(lazy(() => import("@/views/book-shelf"))),
        path: '/index/book-shelf',
    },
    // {
    //     name: "我",
    //     icon: <UserIcon />,
    //     active: <UserIconSolid />,
    //     element: lazyLoad(lazy(() => import("@/views/me"))),
    //     path: '/index/me',
    // },
];

// [
//     // {
//     //     path: '/index',
//     //     element: lazyLoad(lazy(() => import("@/views/index"))),
//     //     meta: { title: '首页' }
//     // },

// ]
export default [
    {
        element: <IndexLayout />,
        children: [
            {
                element: <NavigationLayout />,
                children: navigationBottomBarRoutes
            }, {
                element: <ViewerLayout />,
                children: [
                    {
                        path: '/viewer',
                        element: lazyLoad(lazy(() => import("@/views/viewer"))),
                        meta: { title: '阅读器' }
                    }
                ]
            }
        ]
    }
] as Array<RouteObject>;